import Image from './src/main';
import '@/theme/css/basic/image.scss';

/* istanbul ignore next */
// Image.install = function(Vue) {
//   Vue.component(Image.name, Image);
// };

export default Image;